export function statusBadgeClass(statusCode) {
  if (!statusCode) return 'whos-in-status-badge whos-in-status-other';
  const code = statusCode.toLowerCase();
  if (code.includes('on_site') || code === 'equipment' || code === 'shipping') {
    return 'whos-in-status-badge whos-in-status-onsite';
  }
  if (code.includes('inbound')) return 'whos-in-status-badge whos-in-status-inbound';
  if (code.includes('outbound')) return 'whos-in-status-badge whos-in-status-outbound';
  if (code.includes('travel') || code === 'transition' || code === 'barge') {
    return 'whos-in-status-badge whos-in-status-travel';
  }
  if (code.includes('home') || code === 'weekend' || code === 'work_from_home') {
    return 'whos-in-status-badge whos-in-status-home';
  }
  return 'whos-in-status-badge whos-in-status-other';
}

export const SCHEDULE_STATUS_LEGEND = [
  { label: 'On site', className: 'whos-in-status-badge whos-in-status-onsite' },
  { label: 'Inbound', className: 'whos-in-status-badge whos-in-status-inbound' },
  { label: 'Outbound', className: 'whos-in-status-badge whos-in-status-outbound' },
  { label: 'Travel', className: 'whos-in-status-badge whos-in-status-travel' },
  { label: 'Home', className: 'whos-in-status-badge whos-in-status-home' },
  { label: 'Other', className: 'whos-in-status-badge whos-in-status-other' },
];

export function scheduleStatusLabel(row) {
  return row?.status_description || row?.status_code || '—';
}
